import styled from "styled-components";
import { ReactComponent as rightArrow } from "../../assets/icons/rightArrow.svg";

 export const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
};
  
export const Container = styled.div`
/* flex: 1; */
  /* width: 100%; */
  height: 426px;
  border: 1px solid #f9f9f9;
  margin-top: 50px;
  box-sizing: border-box;
  background: #ffffff;
`;

export const TextWrapper = styled.div`
  display: flex;
`;

export const Text = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #151515;
  height: 27px;
  text-align: center;
  margin: 65px 0 0 30px;
`;

export const Button = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  color: #151515;
  background: #ffffff;
  border-radius: 8px;
  margin-left: auto;
  margin-top: auto;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-right: 45px;
  cursor: pointer;
  :active {
    transform: scale(0.95);
  }
`;
export const Icons = styled.div``;
Icons.RightArrow = styled(rightArrow)`
  width: 5px;
  height: 10px;
  font-size: 15px;
  margin-left: 10px;
  & path {
    stroke: #6a983c;
  }
`;
export const ImgArrow = styled.div``;

export const ShadowWrapper = styled.div`
  position: absolute;
  width: 95px;
  height: 240px;
  top: 230px;
  ${(props) => {
    if (props.position) {
      return `
      right:0px;
      transform: rotate(180deg);`;
    } else {
      return `
      left:0px`;
    }
  }};

  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  opacity: 0.7;

`;
